import { useEffect, useState } from "react";

import type { ContentAreaRect } from "@/components/VibeChat/widgets/FloatingWidget/hooks/useContentAreaCenter";

const CONTENT_AREA_RESIZE_SETTLE_MS = 150;
const FULLSCREEN_TRANSITION_MS = 500;

export const useDeferChartsDuringLayoutChange = ({
  contentBounds,
  isFullscreen,
  isResizing,
}: {
  contentBounds: ContentAreaRect | null;
  isFullscreen: boolean;
  isResizing: boolean;
}) => {
  const [isContentAreaChanging, setIsContentAreaChanging] = useState(false);
  const [isFullscreenTransitioning, setIsFullscreenTransitioning] = useState(false);

  useEffect(() => {
    setIsFullscreenTransitioning(true);
    const timer = window.setTimeout(() => {
      setIsFullscreenTransitioning(false);
    }, FULLSCREEN_TRANSITION_MS);

    return () => window.clearTimeout(timer);
  }, [isFullscreen]);

  useEffect(() => {
    if (!contentBounds) {
      return;
    }

    setIsContentAreaChanging(true);
    const timer = window.setTimeout(() => {
      setIsContentAreaChanging(false);
    }, CONTENT_AREA_RESIZE_SETTLE_MS);

    return () => window.clearTimeout(timer);
  }, [
    contentBounds?.height,
    contentBounds?.left,
    contentBounds?.top,
    contentBounds?.width,
    contentBounds,
  ]);

  return isResizing || isContentAreaChanging || isFullscreenTransitioning;
};
